import { push } from 'connected-react-router';

export const Teste = () => dispatch =>{
    return (new Promise( resolve =>{
        setTimeout(() =>{
            dispatch(push('/profile'))
        }, 3000)
    }))
}
export const navigate = route => dispatch =>{
    return (new Promise( resolve =>{
        dispatch(push(route))
    }))
}


// WEBPACK FOOTER //
// ./src/actions/routerResolve.js